// test1123
(1123 && 0);
